"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const airbridge_web_sdk_loader_1 = __importDefault(require("airbridge-web-sdk-loader"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const services_1 = __importDefault(require("@/helpers/services"));
const selectors_1 = __importDefault(require("@/selectors"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SubscribeScreen = ({ location, productToSubscription }) => {
    var _a;
    const [productId] = (0, react_1.useState)((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.productID);
    const [name, setName] = (0, react_1.useState)('');
    const [messages, _setMessages] = (0, react_1.useState)('');
    const [paymentMethodSuccess, setPaymentSuccess] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [disabled, setDisabled] = (0, react_1.useState)(true);
    const setMessage = (message) => {
        _setMessages(`${messages}\n\n${message}`);
    };
    const stripe = (0, react_stripe_js_1.useStripe)();
    const elements = (0, react_stripe_js_1.useElements)();
    if (!stripe || !elements) {
        return null;
    }
    const handleChangeCard = (event) => __awaiter(void 0, void 0, void 0, function* () {
        setDisabled(!event.complete);
    });
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setLoading(true);
        const payload = yield stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(react_stripe_js_1.CardElement),
            billing_details: {
                name,
            },
        });
        if (payload.error) {
            setMessage(payload.error.message);
            setLoading(false);
        }
        else {
            airbridge_web_sdk_loader_1.default.events.send('airbridge.addPaymentInfo');
            const result = yield services_1.default.createSubscription({ product_id: productId, source_id: payload.paymentMethod.id });
            const subscriptionResult = result.find(element => !!element);
            if (subscriptionResult.statusCode === 200) {
                setPaymentSuccess(true);
            }
            else {
                setMessage(subscriptionResult === null || subscriptionResult === void 0 ? void 0 : subscriptionResult.details);
                setLoading(false);
            }
        }
    });
    if (paymentMethodSuccess) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: { pathname: constants_1.Routes.Subscriptions, state: { success: true } } });
    }
    return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
        react_1.default.createElement("h1", null, constants_1.default.subscriptions.subHabitnest),
        !!productToSubscription && (react_1.default.createElement("div", { className: styles_scss_1.default.textContainer },
            react_1.default.createElement("h4", { className: styles_scss_1.default.productName }, productToSubscription.product_data.name),
            react_1.default.createElement("p", { className: styles_scss_1.default.productDescription }, productToSubscription.product_data.description),
            react_1.default.createElement("h3", { className: styles_scss_1.default.productPrice },
                "$ ",
                productToSubscription.unit_amount / 100))),
        react_1.default.createElement("form", { className: styles_scss_1.default.paymentForm, onSubmit: handleSubmit },
            react_1.default.createElement(components_1.Input, { id: "name", value: name, placeholder: constants_1.default.subscriptions.fullName, label: constants_1.default.subscriptions.fullName, onChange: (e) => setName(e.target.value) }),
            react_1.default.createElement(react_stripe_js_1.CardElement, { id: "card-element", options: styles_1.default.cardStyle, className: styles_scss_1.default.cardInput, onChange: handleChangeCard }),
            loading ? (react_1.default.createElement("span", { className: styles_scss_1.default.loading }, constants_1.default.subscriptions.loading)) : (react_1.default.createElement(components_1.Button, { type: "submit", title: constants_1.default.subscriptions.subscribe, className: styles_scss_1.default.submitButton, disabled: (disabled || name.length < 3) }))),
        react_1.default.createElement("p", { className: styles_scss_1.default.agreementTextFirst }, constants_1.default.subscriptions.textAgreement),
        react_1.default.createElement("p", { className: styles_scss_1.default.agreementText }, constants_1.default.subscriptions.textAgreementSecond),
        !!messages && (react_1.default.createElement("div", { className: styles_scss_1.default.bannerContainer },
            react_1.default.createElement(components_1.Banner, { title: messages, backgroundColor: styles_scss_1.default.bannerRed, width: "100%" })))));
};
const mapStateToProps = (state, props) => {
    var _a, _b;
    return ({
        productToSubscription: selectors_1.default.payment.getSubscription(state, (_b = (_a = props === null || props === void 0 ? void 0 : props.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.productID)
    });
};
SubscribeScreen.defaultProps = {
    productToSubscription: null,
    location: null
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, null)(SubscribeScreen);
